const PLACEHOLDER_START = '${'

const isDom = typeof window !== 'undefined' && typeof document !== 'undefined'
const globals = isDom ? (window as any) : {}

const cache: Record<string, string | string[]> = {}

const cleanAndSplit = (v: string, d = ','): string[] => v.replace(/\s+/g, '').split(d).filter(Boolean)

function resolveEnv(name: string, attr?: string, asArray = false): string | string[] {
    const cacheKey = `${name}:${asArray}`
    if (cacheKey in cache) return cache[cacheKey]

    const varName = `VITE_${name}`
    let val: string | undefined
    let source: string | null = null

    val = import.meta.env?.[varName]
    if (val !== undefined && val !== `${PLACEHOLDER_START}${varName}}`) {
        source = 'import.meta.env'
    }

    if (!val && globals?.[varName] && globals[varName] !== `${PLACEHOLDER_START}${varName}}`) {
        val = globals[varName]
        source = 'window'
    }

    if (!val && isDom && attr) {
        try {
            if (document.readyState === 'interactive' || document.readyState === 'complete') {
                const attrVal = document.body?.getAttribute(attr)
                if (attrVal && !attrVal.startsWith(PLACEHOLDER_START)) {
                    val = attrVal
                    source = `document.body[data-${attr}]`
                }
            } else {
                console.warn(`[env] Skipping DOM fallback for ${varName} — DOM not ready`)
            }
        } catch (e) {
            console.warn(`[env] Failed reading DOM attribute for ${varName}:`, e)
        }
    }

    if (!val || val.trim() === '') {
        console.error(`[env] ${varName} could not be resolved from any source.`)
        throw new Error(`[env] Missing environment variable: ${varName}`)
    }

    const finalVal = asArray ? cleanAndSplit(val) : val
    cache[cacheKey] = finalVal
    return finalVal
}

export const environment = {
    get AD_TENANT_ID(): string {
        return resolveEnv('AD_TENANT_ID', 'data-tenant-id') as string
    },
    get AD_CLIENT_ID(): string {
        return resolveEnv('AD_CLIENT_ID', 'data-client-id') as string
    },
    get BACKEND_API_SCOPE(): string[] {
        return resolveEnv('BACKEND_API_SCOPE', 'data-api-scope', true) as string[]
    },
    get BACKEND_URL(): string {
        return resolveEnv('BACKEND_URL', 'data-backend-url') as string
    },
    get ENVIRONMENT(): string {
        return resolveEnv('ENVIRONMENT', 'data-environment') as string
    },
}
